import { gql } from "@apollo/client";

export const addJourney = gql`
    mutation (
        $name: String!
        $state: String!
        $flow: JSON!
        $version: Int!
        $usedNodeCount: Int
        $description: String
    ) {
        createJourney(
            createJourneyInput: {
                name: $name
                state: $state
                flow: $flow
                version: $version
                usedNodeCount: $usedNodeCount
                description: $description
            }
        ) {
            id
            friendlyId
            state
            version
        }
    }
`;

export const updateJourney = gql`
    mutation ($id: String!, $name: String!, $state: String!, $flow: JSON!, $version: Int!, $usedNodeCount: Int) {
        updateJourney(
            id: $id
            updateJourneyInput: {
                name: $name
                state: $state
                flow: $flow
                version: $version
                usedNodeCount: $usedNodeCount
            }
        ) {
            id
            friendlyId
            state
            version
        }
    }
`;

export const updateJourneyDetails = gql`
    mutation ($id: String!, $name: String!, $description: String, $tags: [String!]) {
        updateJourneyDetails(
            id: $id
            updateJourneyDetailsInput: { name: $name, description: $description, tags: $tags }
        ) {
            id
            name
            description
            tags {
                id
                name
            }
        }
    }
`;

export const removeJourney = gql`
    mutation ($id: String!) {
        removeJourney(id: $id) {
            id
        }
    }
`;

export const stopJourney = gql`
    mutation ($id: String!, $version: Int!) {
        stopJourney(id: $id, stopJourneyInput: { version: $version }) {
            id
            friendlyId
            state
            version
        }
    }
`;

export const upsertJourneysStickyNote = gql`
    mutation ($journeyId: String!, $stickyNote: StickyNoteInput!) {
        upsertJourneysStickyNote(journeyId: $journeyId, stickyNote: $stickyNote) {
            journeyId
            nodeId
            data
        }
    }
`;

export const bulkUpsertJourneysStickyNotes = gql`
    mutation ($journeyId: String!, $stickyNotesInput: StickyNotesInput!) {
        upsertJourneysStickyNotes(journeyId: $journeyId, stickyNotesInput: $stickyNotesInput) {
            upsertedIds
        }
    }
`;

export const deleteJourneysStickyNote = gql`
    mutation ($journeyId: String!, $nodeId: String!) {
        deleteJourneysStickyNote(journeyId: $journeyId, nodeId: $nodeId) {
            journeyId
            nodeId
        }
    }
`;

export const restoreJourney = gql`
    mutation restoreJourney($input: RestoreJourneyInput!) {
        restoreJourney(input: $input) {
            id
            version
        }
    }
`;
